module.exports = __webpack_public_path__ + "img/si.9a72ead.svg";